import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getButtonClasses } from '@/components/ui/atoms/Button';

export const NotFoundPage: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-marine-100 p-4">
      <div className="text-center max-w-md">
        <h1 className="text-9xl font-bold text-primary">404</h1>
        <div className="text-6xl font-bold mb-4">¯\_(ツ)_/¯</div>
        <h2 className="text-2xl font-semibold mb-4">{t('errors.not_found_title')}</h2>
        <p className="text-marine-600 mb-6">{t('errors.not_found_desc')}</p>
        <div className="mb-8 text-marine-500 italic">{t('errors.not_found_quote')}</div>
        <Link
          to="/"
          className={getButtonClasses(
            'contained',
            'secondary',
            'md',
            false,
            'no-underline',
          )}
        >
          {t('errors.take_me_home')}
        </Link>
      </div>
    </div>
  );
};
